(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[244],{

/***/ 1696:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/end/credit",
      function () {
        return __webpack_require__(6445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ credit; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/gsap/dist/gsap.js
var gsap = __webpack_require__(458);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollTrigger.js
var ScrollTrigger = __webpack_require__(4605);
// EXTERNAL MODULE: ./node_modules/gsap/dist/ScrollToPlugin.js
var ScrollToPlugin = __webpack_require__(760);
// EXTERNAL MODULE: ./pages/story/end/credit/credit.module.scss
var credit_module = __webpack_require__(2785);
var credit_module_default = /*#__PURE__*/__webpack_require__.n(credit_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/layout/index.js + 5 modules
var layout = __webpack_require__(5962);
// EXTERNAL MODULE: ./public/images/credit-bg.jpg
var credit_bg = __webpack_require__(2133);
;// CONCATENATED MODULE: ./public/images/credit-logos.png
/* harmony default export */ var credit_logos = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/credit-logos.c8e5baa8.png","height":154,"width":1104,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAK0lEQVR4nGM8vWetoM+qdywvP//5V/Iy83fPPu7/bbGu3J/UIpk+sYv+BQBAkhHLORs36QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/images/cLogo-bg.png
/* harmony default export */ var cLogo_bg = ({"src":"/wp-content/themes/GKH-Theme/bamistarim/_next/static/media/cLogo-bg.6aac5dd8.png","height":180,"width":1320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAKUlEQVR4nGN8+ezBS1Y2dgYWVg4GRkZGBgYg+v//P8O/f/8Y/v39wwAAsCwMr/cTsKYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./pages/story/end/credit/index.js













// Register Plugin
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger, ScrollToPlugin.ScrollToPlugin);
function StoryCredit(param) {
    var dataAudio = param.dataAudio, dataAudio2 = param.dataAudio2;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var bgData = {
        bgImage: credit_bg/* default */.Z
    };
    var pageData = {
        section1: {
            title: "קרדיטים",
            credits: [
                {
                    title: "הובלה וניהול פרויקט",
                    name: "נעמי גלבך",
                    id: 1
                },
                {
                    title: "תוכן וארכיון",
                    name: "טובה יוסקוביץ",
                    id: 2
                },
                {
                    title: "ייעוץ היסטורי",
                    name: "גב’ אסתר פרבשטיין",
                    id: 3
                },
                {
                    title: "כתיבת תוכן",
                    name: "רחל שטיינהויז",
                    id: 4
                },
                {
                    title: "אפיון ועיצוב",
                    name: "נעמי גלבך, יובל אלבג",
                    id: 5
                },
                {
                    title: "איור ואנימציה",
                    name: "תמר דדון-רווה",
                    id: 6
                },
                {
                    title: "איור",
                    name: "נעה פלד",
                    id: 7
                },
                {
                    title: "מחקר היסטורי סגנוני",
                    name: "אפרת יפה",
                    id: 8
                },
                {
                    title: "פיתוח",
                    name: "SiTo",
                    link: "https://sito.ltd/?utm_source=bamistarim&utm_medium=credit&utm_campaign=bamistarim",
                    target: "_blank",
                    id: 9
                },
                {
                    title: "מוסיקה מקורית ועיצוב סאונד",
                    name: "דניאל שמר",
                    id: 10
                },
                {
                    title: "הפקת פודקאסטים",
                    name: "רבקי וקסלר",
                    id: 11
                },
                {
                    title: "קטעי תיעוד ותמונות",
                    name: "ארכיון גנזך קדוש השם",
                    id: 12
                }
            ]
        },
        section2: {
            content: '<p>With Assistance from the Conference on Jewish Material Claims Against Germany<br/>Sponsored by the Foundation "Remembrance, Responsibility and Future"<br/>Supported by the German Federal Ministry of Finance</p>'
        },
        logoSection: {
            logos: credit_logos,
            creditBG: cLogo_bg
        }
    };
    //console.log(pageData?.logoSection?.creditBG?.src);
    // Set Counter
    var ref16 = (0,react.useState)(1), counter = ref16[0], setCounter = ref16[1];
    // Use Ref
    var scroller = (0,react.useRef)(null);
    var credits = (0,react.useRef)(null);
    // Router
    var router = (0,next_router.useRouter)();
    //console.log(router.asPath);
    (0,react.useEffect)(function() {
        var contain = document.querySelector(".vertical-wrapper");
        /* console.log(window.innerHeight);
        console.log(scroller.current.scrollHeight);
        if(scroller.current){
            ScrollTrigger.create({
                trigger: scroller.current,
                start: "top top",
                end: () => (scroller.current.scrollHeight - window.innerHeight),
                pin: true,
                anticipatePin: 1,
                scrub: 2,
                invalidateOnRefresh: true,
            });
        } */ // Timeline
        if (credits) {
            var auto = gsap.gsap.timeline({
                repeat: 0,
                delay: 3
            }).to(credits.current, {
                y: function() {
                    return -(credits.current.scrollHeight - window.innerHeight);
                },
                duration: 20,
                progress: 0.5,
                ease: "none",
                autoKill: true
            });
            auto.resume();
            contain.addEventListener("wheel", function(e) {
                var time = 1;
                if (e.deltaY < 0) {
                    if (e.deltaY < -100) {
                        time = time + 0.5;
                    } else if (e.deltaY < -200) {
                        time = time + 1;
                    } else if (e.deltaY < -300) {
                        time = time + 1.5;
                    } else if (e.deltaY < -400) {
                        time = time + 2;
                    } else {
                        time = time + 3;
                    }
                    auto.timeScale(time).reverse();
                } else {
                    if (e.deltaY < 100) {
                        time = time + 0.5;
                    } else if (e.deltaY < 200) {
                        time = time + 1;
                    } else if (e.deltaY < 300) {
                        time = time + 1.5;
                    } else if (e.deltaY < 400) {
                        time = time + 2;
                    } else {
                        time = time + 3;
                    }
                    auto.timeScale(time).play();
                }
            });
        }
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        header: "show",
        footer: "hide",
        mainDir: "ltr",
        audio: dataAudio,
        audio2: dataAudio2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "vertical-wrapper relative h-screen w-screen overflow-hidden z-10 flex flex-nowrap flex-row-reverse bg-no-repeat bg-fixed bg-center bg-cover ".concat((credit_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-0 w-full h-full z-10 ".concat((credit_module_default()).background),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "block w-full h-full object-cover object-center",
                            src: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.src */.Z.src,
                            width: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.width */.Z.width,
                            height: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.height */.Z.height,
                            blurDataURL: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.blurDataURL */.Z.blurDataURL,
                            placeholder: "blur",
                            alt: credit_bg/* default */.Z === null || credit_bg/* default */.Z === void 0 ? void 0 : credit_bg/* default.alt */.Z.alt
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "v-section w-screen h-auto z-50 flex content-center justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-screen h-auto creditScroll",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: scroller,
                                    className: "w-screen h-auto section-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        ref: credits,
                                        className: "".concat((credit_module_default()).creditContent),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (credit_module_default()).section1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: (credit_module_default()).title,
                                                        children: pageData === null || pageData === void 0 ? void 0 : (ref = pageData.section1) === null || ref === void 0 ? void 0 : ref.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "credits",
                                                        children: pageData === null || pageData === void 0 ? void 0 : (ref1 = pageData.section1) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.credits) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex justify-between ".concat((credit_module_default()).singleList),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (credit_module_default()).listLeft,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: item.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: item.link,
                                                                                target: item.target,
                                                                                children: item.name
                                                                            }) : item.name
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (credit_module_default()).listRight,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: item.title
                                                                        })
                                                                    })
                                                                ]
                                                            }, item.id);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (credit_module_default()).section2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "credits m-auto max-w-4xl text-center",
                                                    dangerouslySetInnerHTML: {
                                                        __html: pageData === null || pageData === void 0 ? void 0 : (ref3 = pageData.section2) === null || ref3 === void 0 ? void 0 : ref3.content
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    backgroundImage: "url('".concat(pageData === null || pageData === void 0 ? void 0 : (ref4 = pageData.logoSection) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.creditBG) === null || ref5 === void 0 ? void 0 : ref5.src, "')")
                                },
                                className: "flex justify-center bg-no-repeat fixed left-0 bottom-0 z-40 w-full ".concat((credit_module_default()).creditLogo),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: pageData === null || pageData === void 0 ? void 0 : (ref6 = pageData.logoSection) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.logos) === null || ref7 === void 0 ? void 0 : ref7.width,
                                    height: pageData === null || pageData === void 0 ? void 0 : (ref8 = pageData.logoSection) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.logos) === null || ref9 === void 0 ? void 0 : ref9.height,
                                    src: pageData === null || pageData === void 0 ? void 0 : (ref10 = pageData.logoSection) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.logos) === null || ref11 === void 0 ? void 0 : ref11.src,
                                    blurDataURL: pageData === null || pageData === void 0 ? void 0 : (ref12 = pageData.logoSection) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.logos) === null || ref13 === void 0 ? void 0 : ref13.blurDataURL,
                                    placeholder: "blur",
                                    alt: pageData === null || pageData === void 0 ? void 0 : (ref14 = pageData.logoSection) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.logos) === null || ref15 === void 0 ? void 0 : ref15.alt
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var credit = (StoryCredit);


/***/ }),

/***/ 760:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

(function(global, factory) {
     true ? factory(exports) : 0;
})(void 0, function(exports1) {
    "use strict";
    /*!
	 * ScrollToPlugin 3.11.3
	 * https://greensock.com
	 *
	 * @license Copyright 2008-2022, GreenSock. All rights reserved.
	 * Subject to the terms at https://greensock.com/standard-license or for
	 * Club GreenSock members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/ var gsap, _coreInitted, _window, _docEl, _body, _toArray, _config, _windowExists = function _windowExists() {
        return "object" !== "undefined";
    }, _getGSAP = function _getGSAP() {
        return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
    }, _isString = function _isString(value) {
        return typeof value === "string";
    }, _isFunction = function _isFunction(value) {
        return typeof value === "function";
    }, _max = function _max(element, axis) {
        var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
        return element === _window || element === _docEl || element === _body ? Math.max(_docEl[scroll], _body[scroll]) - (_window["inner" + dim] || _docEl[client] || _body[client]) : element[scroll] - element["offset" + dim];
    }, _buildGetter = function _buildGetter(e, axis) {
        var p = "scroll" + (axis === "x" ? "Left" : "Top");
        if (e === _window) {
            if (e.pageXOffset != null) {
                p = "page" + axis.toUpperCase() + "Offset";
            } else {
                e = _docEl[p] != null ? _docEl : _body;
            }
        }
        return function() {
            return e[p];
        };
    }, _clean = function _clean(value, index, target, targets) {
        _isFunction(value) && (value = value(index, target, targets));
        if (typeof value !== "object") {
            return _isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
                x: value,
                y: value
            } : {
                y: value
            };
        } else if (value.nodeType) {
            return {
                y: value,
                x: value
            };
        } else {
            var result = {}, p;
            for(p in value){
                result[p] = p !== "onAutoKill" && _isFunction(value[p]) ? value[p](index, target, targets) : value[p];
            }
            return result;
        }
    }, _getOffset = function _getOffset(element, container) {
        element = _toArray(element)[0];
        if (!element || !element.getBoundingClientRect) {
            return console.warn("scrollTo target doesn't exist. Using 0") || {
                x: 0,
                y: 0
            };
        }
        var rect = element.getBoundingClientRect(), isRoot = !container || container === _window || container === _body, cRect = isRoot ? {
            top: _docEl.clientTop - (_window.pageYOffset || _docEl.scrollTop || _body.scrollTop || 0),
            left: _docEl.clientLeft - (_window.pageXOffset || _docEl.scrollLeft || _body.scrollLeft || 0)
        } : container.getBoundingClientRect(), offsets = {
            x: rect.left - cRect.left,
            y: rect.top - cRect.top
        };
        if (!isRoot && container) {
            offsets.x += _buildGetter(container, "x")();
            offsets.y += _buildGetter(container, "y")();
        }
        return offsets;
    }, _parseVal = function _parseVal(value, target, axis, currentVal, offset) {
        return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : _isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? _max(target, axis) - offset : Math.min(_max(target, axis), _getOffset(value, target)[axis] - offset);
    }, _initCore = function _initCore() {
        gsap = _getGSAP();
        if (_windowExists() && gsap && document.body) {
            _window = window;
            _body = document.body;
            _docEl = document.documentElement;
            _toArray = gsap.utils.toArray;
            gsap.config({
                autoKillThreshold: 7
            });
            _config = gsap.config();
            _coreInitted = 1;
        }
    };
    var ScrollToPlugin = {
        version: "3.11.3",
        name: "scrollTo",
        rawVars: 1,
        register: function register(core) {
            gsap = core;
            _initCore();
        },
        init: function init(target, value, tween, index, targets) {
            _coreInitted || _initCore();
            var data = this, snapType = gsap.getProperty(target, "scrollSnapType");
            data.isWin = target === _window;
            data.target = target;
            data.tween = tween;
            value = _clean(value, index, target, targets);
            data.vars = value;
            data.autoKill = !!value.autoKill;
            data.getX = _buildGetter(target, "x");
            data.getY = _buildGetter(target, "y");
            data.x = data.xPrev = data.getX();
            data.y = data.yPrev = data.getY();
            gsap.getProperty(target, "scrollBehavior") === "smooth" && gsap.set(target, {
                scrollBehavior: "auto"
            });
            if (snapType && snapType !== "none") {
                data.snap = 1;
                data.snapInline = target.style.scrollSnapType;
                target.style.scrollSnapType = "none";
            }
            if (value.x != null) {
                data.add(data, "x", data.x, _parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
                data._props.push("scrollTo_x");
            } else {
                data.skipX = 1;
            }
            if (value.y != null) {
                data.add(data, "y", data.y, _parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
                data._props.push("scrollTo_y");
            } else {
                data.skipY = 1;
            }
        },
        render: function render(ratio, data) {
            var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            x = isWin || !data.skipX ? data.getX() : xPrev;
            y = isWin || !data.skipY ? data.getY() : yPrev;
            yDif = y - yPrev;
            xDif = x - xPrev;
            threshold = _config.autoKillThreshold;
            if (data.x < 0) {
                data.x = 0;
            }
            if (data.y < 0) {
                data.y = 0;
            }
            if (autoKill) {
                if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < _max(target, "x")) {
                    data.skipX = 1;
                }
                if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < _max(target, "y")) {
                    data.skipY = 1;
                }
                if (data.skipX && data.skipY) {
                    tween.kill();
                    data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
                }
            }
            if (isWin) {
                _window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
            } else {
                data.skipY || (target.scrollTop = data.y);
                data.skipX || (target.scrollLeft = data.x);
            }
            if (snap && (ratio === 1 || ratio === 0)) {
                y = target.scrollTop;
                x = target.scrollLeft;
                snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
                target.scrollTop = y + 1;
                target.scrollLeft = x + 1;
                target.scrollTop = y;
                target.scrollLeft = x;
            }
            data.xPrev = data.x;
            data.yPrev = data.y;
        },
        kill: function kill(property) {
            var both = property === "scrollTo";
            if (both || property === "scrollTo_x") {
                this.skipX = 1;
            }
            if (both || property === "scrollTo_y") {
                this.skipY = 1;
            }
        }
    };
    ScrollToPlugin.max = _max;
    ScrollToPlugin.getOffset = _getOffset;
    ScrollToPlugin.buildGetter = _buildGetter;
    _getGSAP() && gsap.registerPlugin(ScrollToPlugin);
    exports1.ScrollToPlugin = ScrollToPlugin;
    exports1.default = ScrollToPlugin;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


/***/ }),

/***/ 2785:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"credit_container__R6nCw","background":"credit_background__qXOin","creditContent":"credit_creditContent__9yL20","section1":"credit_section1__zjpc4","title":"credit_title__JcVdF","singleList":"credit_singleList__Dpxi7","listLeft":"credit_listLeft__AKttV","listRight":"credit_listRight__OhEoO","section2":"credit_section2__VEtqU","creditLogo":"credit_creditLogo__wVsYz","button":"credit_button__vlbqi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [362,605,962,774,888,179], function() { return __webpack_exec__(1696); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);